import React, { useContext } from 'react';
import { Button, mergeClasses } from '@fluentui/react-components';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import { BeachIcon } from './media/beach-icon';
import { useNoConversationsViewStyles } from './styles';
import type { NoConversationsViewProps } from './types';

export const NoConversationsView = (props: NoConversationsViewProps) => {
  const { onStartNewChat } = props;

  const i18n = useContext(I18nContext) as I18nModel;
  const styles = useNoConversationsViewStyles();

  return (
    <div className={mergeClasses(styles.container, 'no-conversations-view')}>
      <BeachIcon />
      <p className={styles.title}>{i18n.getString(_TL_('No chat history.'))}</p>

      <p className={styles.subtitle}>{i18n.getString(_TL_('Start a chat and it will be saved here.'))}</p>
      <Button onClick={onStartNewChat} className={mergeClasses(styles.button, 'start-chat')}>{i18n.getString(_TL_('Start chat'))}</Button>
    </div>
  );
};
